<div *ngIf="projectCostInfo" class="p-grid">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>ITD Cost</label>
  </div>
  <!-- Todo: need to handle contract/clin with multiple projects-->
  <div class="p-col-12 p-md-8 p-lg-8">
    <div *ngIf="projectCostInfo.length>0">
      {{projectCostInfo[0].totalCostITD | currency: Format.Currency}}
      <button pButton type="button" class="icon-action" icon="fa fa-eye" pTooltip="Show Details" tooltipPosition="top"
              (click)="itdDetail.toggle($event)"
              [disabled]="projectCostInfo?.length===0"></button>
    </div>
    <div *ngIf="projectCostInfo.length===0">
      {{0 | currency: Format.Currency}}
    </div>
  </div>
</div>

<div class="p-grid">
  <div class="p-col-12 p-md-4 p-lg-4">
    <label>Estimate at Completion</label>
  </div>
  <div *ngIf="latestEstimatedCompletion" class="p-col-12 p-md-8 p-lg-8">
    <span class="p-inputgroup">
      <span class="p-inputgroup-addon">$</span>
      <input pInputText type="text" [pattern]="RegExp12DigitInteger2DigitFraction"
             [(ngModel)]="latestEstimatedCompletion.estimatedCost"/>

      <!-- Todo: need to handle contract/clin with multiple projects-->
      <button pButton type="button" class="button-action" icon="fa fa-save" pTooltip="Save Estimated Completion" tooltipPosition="top" style="margin-left:5px;"
              (click)="onClickUpdateEstimatedCompletion(latestEstimatedCompletion, projectCostInfo[0]?.totalCostITD, invoicingPeriod)"></button>
      <button pButton type="button" class="icon-action" icon="fa fa-eye" pTooltip="Show History" tooltipPosition="top" style="margin-left:5px;"
              (click)="history.toggle($event)"
              [disabled]="estimatedCompletions?.length===0"></button>
    </span>
  </div>
</div>

<div class="p-grid">
  <div *ngIf="projectCostInfo" class="p-col-12 p-md-4 p-lg-4">
    <label>Suggested Percent Completion
      <button pButton icon="fa fa-info-circle" tooltipPosition="top" class="help-tip" pTooltip="Incurred Cost / Estimate at Completion"></button>
    </label>
  </div>
  <!-- Todo: need to handle contract/clin with multiple projects-->
  <div *ngIf="projectCostInfo&&latestEstimatedCompletion?.estimatedCost" class="p-col-12 p-md-8 p-lg-8">
    {{projectCostInfo[0]?.totalCostITD / latestEstimatedCompletion.estimatedCost  | percent: Format.PercentOneDotTwoDecimal}}
  </div>
</div>

<p-overlayPanel #history appendTo="body" [showCloseIcon]="true" [style]="{width: '600px'}">
  <app-data-table [columns]="estimatedCompletionsTableColumns" [value]="estimatedCompletions" sortField="updatedOn"
                  [captionTemplate]="captionTemplate" [disableSearch]="true">
    <ng-template #captionTemplate>
      <div class="p-col-12" style="text-align:center;">
        Estimated Completion
      </div>
    </ng-template>
  </app-data-table>
</p-overlayPanel>

<p-overlayPanel #itdDetail appendTo="body" [showCloseIcon]="true" [style]="{width: '600px'}">
  <app-data-table [columns]="projectItdTableColumns" [value]="projectCostInfo"
                  [captionTemplate]="captionTemplate" [disableSearch]="true">
    <ng-template #captionTemplate>
      <div class="p-col-12" style="text-align:center;">
        Project ITD Cost Detail
      </div>
    </ng-template>
  </app-data-table>
</p-overlayPanel>
